import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class ProductionStage extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      productionStageList: [],
      productionStageDetails: {
        stageName: "",
      },
    };
  }

  componentDidMount() {
    this.getAllProductionStageMaster();
  }

  getAllProductionStageMaster = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllProductionStageMaster().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        const sortedData = response.responseData.sort((a, b) => a.seqNo - b.seqNo);
        this.setState(
          { productionStageList: sortedData },);
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditProductionStages = () => {
    if (this.state.productionStageDetails.stageName !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.productionStageDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices
          .addEditProductionStages(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.resetForm();
              this.setState({ isLoading: false })
              this.SwalServices.Success(response.Message);
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false })
            }
          });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.productionStageDetails;
    details.stageName = "";
    this.setState({ productionStageDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllProductionStageMaster();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.productionStageDetails;
    details[name] = value.toUpperCase();
    this.setState({ productionStageDetails: details });
  };

  getProductionStageById = (group) => {
    let details = this.state.productionStageDetails;
    details.stageName = group.stageName;
    this.setState({ productionStageDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteProductionStageById = (id) => {
    this.itemMasterServices.deleteProductionStageById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllProductionStageMaster();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp w-[50%] !mb-3.5">
              <label>Stage Name</label>
              <input
                className="inputFocus"
                type="text"
                id="stageName"
                name="stageName"
                autoComplete="off"
                value={this.state.productionStageDetails.stageName}
                onChange={(event) => this.handleChange(event, "stageName")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditProductionStages()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditProductionStages()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading} >
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '75%' }}>Stag Name</td>
                    <td style={{ width: '10%' }}>Seq No</td>
                    {/* <td>Stag Code</td> */}
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.productionStageList &&
                    this.state.productionStageList.length > 0 ?
                    this.state.productionStageList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.stageName}</td>
                        <td>{group.seqNo}</td>
                        {/* <td>{group.code}</td> */}
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getProductionStageById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          {/* <button
                            className="cancel-btn"
                            onClick={() =>
                              this.deleteProductionStageById(group._id)
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button> */}
                        </td>
                      </tr>
                    )) : this.state.productionStageList &&
                      this.state.productionStageList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.productionStageList &&
                      this.state.productionStageList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductionStage;
